import { AssetPopularDestinationsBase } from './asset-popular-destinations.base';

export const AssetPopularDestinations = {
  ...AssetPopularDestinationsBase,
  FLIGHTS: [
    'MEX', 'CUN', 'MTY', 'GDL', 'MID', 'PVR', 'LAX'
  ],
  HOTELS: [
    'MEX', 'MTY', 'GDL', 'CUN', 'PVR', 'MZT', 'LAS'
  ],
  AUTOS: [
    'CUN', 'GDL', 'MID', 'MTY', 'MEX', 'PBC', 'LAX'
  ],
  BUSES: [],
  PACKAGES: [
    'CUN', 'PVR', 'MEX', 'GDL', 'SJD', 'MTY', 'LAS'
  ],
  TOUR_AND_ACTIVITIES: [
    'CUN', 'RM4', 'PCM', 'MEX', 'LAX', 'ORL'
  ]
};
